module.exports = __webpack_public_path__ + "img/pin_selected.32ef61de.svg";